import { Box, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";

type WelcomeProps = {
  firstName?: string;
  educationDetails: boolean;
  profile: boolean;
};

const Welcome = ({ firstName}: WelcomeProps) => {
  return (
    <>
    <WelcomeBox>
        <Typography  sx={{fontSize:"14px",fontWeight:600, color:" #3F3F40"}}>
        Welcome{" "} 
        <Typography component="span" sx={{ color:  "info.main",fontSize:"14px",fontWeight:600}}>
            {firstName
              ? (firstName as string).charAt(0).toUpperCase() +
                (firstName as string).slice(1)
              : "User"},{" "}  </Typography>
          </Typography>
          
        <br />
        <Typography color="info.main" className="welcomeSub" style={{color:"#3F3F40",fontSize:"12px"}}>
          Welcome to the 6D Learning Platform! We’re thrilled to have you as
          part of our learning community. Here, you’ll gain skills, insights,
          and hands-on experience in courses designed to empower your journey
          towards knowledge and impact.
        </Typography>
      </WelcomeBox>
    </>
  );
};

export default Welcome;
const WelcomeBox = styled(Box)`
  background-color: white;
  padding: 30px 30px 50px 30px;
  border-radius: 5px;
`;
